export const SET_STEP = 'SET_STEP'
export const SET_ADDRESSES = 'SET_ADDRESSES'



// WEBPACK FOOTER //
// ./src/store/modules/admin/usps/types.js